import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { waLink, WA_MESSAGES } from "../lib/whatsapp";

const Founder = () => (
  <section className="relative py-16 sm:py-20">
    <div className="mx-auto max-w-6xl px-5">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="glass glow-card grid items-center gap-8 rounded-[2rem] p-7 sm:p-10 md:grid-cols-[240px_1fr] md:gap-12"
        data-testid="founder-section"
      >
        <div className="relative mx-auto w-48 shrink-0 md:w-full">
          <img
            src="/images/founder.webp"
            alt="Emily Estevão, Responsável pela ED LABS"
            loading="lazy"
            className="aspect-[4/5] w-full rounded-3xl object-cover object-top shadow-[0_0_50px_rgba(124,58,237,0.3)] ring-1 ring-brand-neon/30"
          />
          <div className="pointer-events-none absolute inset-0 rounded-3xl bg-[linear-gradient(to_top,rgba(9,9,11,0.25),transparent_40%)]" />
        </div>
        <div>
          <p className="mb-3 flex items-center gap-3 font-display text-[11px] font-bold uppercase tracking-[0.35em] text-brand-neon">
            <span className="h-px w-8 bg-brand-neon/60" />
            Por trás da ED LABS
          </p>
          <h2 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl">
            Emily Estevão
          </h2>
          <p className="mt-1 text-sm font-semibold text-brand-neon">
            Responsável pela ED LABS
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-mist sm:text-base">
            “À frente da ED LABS, acredito que tecnologia e estratégia devem
            caminhar juntas. Nosso objetivo é transformar ideias em soluções
            digitais profissionais, com atenção aos detalhes e às necessidades
            de cada negócio.”
          </p>
          <a
            href={waLink(WA_MESSAGES.general)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="founder-whatsapp-cta"
            className="group mt-5 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:text-brand-neon"
          >
            Conversar comigo
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default Founder;
